module.exports = __webpack_public_path__ + "img/btn2.aaa59135.png";